import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-existing-contract-dialog',
  templateUrl: './existing-contract-dialog.component.html',
  styleUrls: ['./existing-contract-dialog.component.scss']
})
export class ExistingContractDialogComponent {

  constructor(public dialogRef: MatDialogRef<ExistingContractDialogComponent>) { }

  public closeDialog(event): void {
    this.dialogRef.close(event);
  }
}
